var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInvite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icInvite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interested-in-this-event-options-scenerio1",
    transform: "translate(-26.000000, -594.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(8.000000, 471.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(18.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icInvite"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1,11.2 C12.1927946,11.2 14.7,8.6927946 14.7,5.6 C14.7,2.5072054 12.1927946,1.55431223e-16 9.1,0 C6.0072054,-1.55431223e-16 3.5,2.5072054 3.5,5.6 C3.50347192,8.69135534 6.00864466,11.1965281 9.1,11.2 Z M9.1,1.4 C11.4195959,1.4 13.3,3.28040405 13.3,5.6 C13.3,7.91959595 11.4195959,9.8 9.1,9.8 C6.78040405,9.8 4.9,7.91959595 4.9,5.6 C4.90231517,3.2813637 6.7813637,1.40231517 9.1,1.4 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5618,12.6 L4.6382,12.6 C2.07798532,12.6027 0.00308642926,14.6772858 0,17.2375 L0,21 L1.4,21 L1.4,17.2375 C1.40231466,15.4501645 2.85086407,14.0019283 4.6382,14 L13.5618,14 C15.3491359,14.0019283 16.7976853,15.4501645 16.8,17.2375 L16.8,21 L18.2,21 L18.2,17.2375 C18.1969136,14.6772858 16.1220147,12.6027 13.5618,12.6 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20.9846 9.0923 18.8923 9.0923 18.8923 7 17.4923 7 17.4923 9.0923 15.4 9.0923 15.4 10.4923 17.4923 10.4923 17.4923 12.5846 18.8923 12.5846 18.8923 10.4923 20.9846 10.4923"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInvite);
export default __webpack_public_path__ + "static/media/icInvite.fa70f03d3150e1b6ede005d0668229f1.svg";
export { ForwardRef as ReactComponent };